"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deepCopy = (o) => JSON.parse(JSON.stringify(o));
/**
 * Represents a Draft
 * @param {Object} course detail object
 * @param {Array.<Object>} sections list of section objects
 * @param {Array.<Object>} contents list of content objects
 * @param {Array.<Object>} contentModules list of content module objects
 */
class Draft {
    constructor(draft) {
        if (!draft) {
            return;
        }
        if (draft.course) {
            this.course = deepCopy(draft.course);
        }
        if (draft.sections) {
            this.sections = deepCopy(draft.sections);
        }
        if (draft.contents) {
            this.contents = deepCopy(draft.contents);
        }
        if (draft.contentModules) {
            this.contentModules = deepCopy(draft.contentModules);
        }
    }
}
exports.default = Draft;
//# sourceMappingURL=Draft.js.map